import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Page } from '../../../models/page.model';
import { Role } from '../../../models/role.model';
import { HttpParams } from '@angular/common/http';
import { RoleService } from '../../../services/role.service';
import { PageChangedEvent } from 'ngx-bootstrap/pagination/public_api';

@Component({
  selector: 'app-selectable-role-list',
  templateUrl: './selectable-role-list.component.html'
})
export class SelectableRoleListComponent implements OnInit {

  roles: Page<Role>;

  @Input() selectedRoles: string[] = [];
  @Output() roleSelected = new EventEmitter<string[]>();

  constructor(private roleService: RoleService) { }

  ngOnInit() {
    this.getRoles();
  }

  onSelectRole(role: Role, index: number) {
    this.roles.content[index].selected = !this.roles.content[index].selected;
    if (role.selected) {
      this.selectedRoles.push(role.code);
    } else {
      this.selectedRoles = this.selectedRoles.filter(item => item !== role.code);
    }
    this.roleSelected.emit(this.selectedRoles);
  }

  private getRoles(page = 1) {

    const params = new HttpParams()
      .set('page', (--page).toString())
      .set('size', '5');

    this.roleService.getRoleList(params).subscribe(res => {
      if (!this.roles) {
        this.roles = res;
      } else {
        this.roles.content = res.content;
      }
      this.setSelectedRoles();
    });
  }

  onPageChanged(event: PageChangedEvent) {
    this.getRoles(event.page);
  }

  private setSelectedRoles() {
    this.roles.content.forEach(item => item.selected = this.selectedRoles.includes(item.code));
  }
}
